import { BookingUserProfileModel, UmbracoClinicModel } from 'src/services/booking';
import { AutomedSiteModel, SiteBaseModel } from 'src/services/site';

export function doctorName(doctor?: BookingUserProfileModel) {
    return doctor && (doctor.automedDisplayName || `${doctor.firstname} ${doctor.surname}`);
}

function isAutomedDetails(clinic: object): clinic is AutomedSiteModel {
    return 'locationDisplayName' in clinic;
}

export function clinicName(clinic?: SiteBaseModel | (UmbracoClinicModel & AutomedSiteModel)) {
    if (!clinic) {
        return undefined;
    }
    if (isAutomedDetails(clinic) && clinic.locationDisplayName) {
        return clinic.locationDisplayName;
    }
    if ('fullName' in clinic && clinic.fullName) {
        return clinic.fullName;
    }
    if (clinic.name.toUpperCase().includes('MYHEALTH')) {
        return clinic.name;
    } else {
        return `Myhealth ${clinic.name}`;
    }
}

export function doctorAvatarSrc(doctor?: BookingUserProfileModel) {
    if (!doctor) {
        return '';
    }
    if (doctor.umbracoProfileUrl) {
        return `${import.meta.env.VITE_MYHEALTH_WEBSITE}${doctor.umbracoProfileUrl}`;
    }
    return doctor.automedProfileUrl;
}
